export class IntakeCheckinSetting {
    statusCode : number;
    message : string;
    data : Data;
  }

  export class Data{
    intakeFormId: string;
    intakeFormName: string;
    isActive: string;
    isDisplayOnTalkPHR: string;
    isDisplayOnTalkCheckIn: string;
    isPatientInformation: string;
    isAllergies: string;
    isMedicationHistory: string;
    isSocialHistory: string;
    isCustomize: string;
    practiceCode: string;
    intakeShowTimeValue: string;
    showIntakeForm: string;
    patientStatus: string;
    isFamilyHistory: string;
    isSurgicalhistory : string ;
    isPasthospitilization : string;    
  }
